<template>
  <div id="watermark" v-if="shouldDisplayWatermark()">
    <p><span class="watermark-header">Application:</span> <span class="watermark-value">{{config.indexPage}}</span></p>
    <p><span class="watermark-header">API Endpoint:</span> <span class="watermark-value">{{config.httpapiEndpoint}}</span></p>
    <p><span class="watermark-header">Branch:</span> <span class="watermark-value">{{config.gerritBranch}}</span></p>
    <p><span class="watermark-header">Build number:</span> <span class="watermark-value">{{config.buildNumber}}</span></p>
  </div>
</template>

<script>

var configs = require('../../config');

const env = process.env.NODE_ENV;
const config = env === 'development' ? configs.dev : configs.build;

export default {
  name: 'Watermark',
  components: {
  },
  props: {
  },
  data () {
    return {
      config: config
    }
  },
  methods: {
    shouldDisplayWatermark: () => {
      var host = window.location.hostname;
      var skipped_host_regexes = [
        /^mycompany\..*\.lumidev\.net$/,
        /^.*\.vevox\.com$/,
        /^.*\.lumiagm\.com$/,
      ];
      var skip_watermark = false;
      for (var re of skipped_host_regexes) {
        skip_watermark = skip_watermark || host.match(re);
      }
      return config.displayWatermark && config.gerritBranch !== 'local' && !skip_watermark;
    }
  },
  computed: {
  },
  mounted() {
  },
  beforeDestroy() {
  },
  watch: {
  }
}
</script>

<style scoped>
#watermark {
  position:fixed;
  bottom:5px;
  right:5px;
  opacity:0.3;
  z-index:99;
  color:black;
  font-family: monospace;
  font-size:small;
  pointer-events: none;
}

#watermark p {
  margin: 0;
  padding: 0;
}

.watermark-header {
  font-weight: bold;
}

@media screen and (max-width: 400px) {
  #watermark {
    font-size: 0.7em;
    white-space: nowrap;
    overflow: hidden;
    left: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Watermark.vue